import styled, { createGlobalStyle } from 'styled-components'
import { Stack } from '@mui/material'

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    touch-action: manipulation;
  }

body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-family: "Montserrat", sans-serif;
    font-size: 16px;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }

  button {
    cursor: pointer;
    touch-action: manipulation !important;

    background: none;
    border: none;
  }

  @media screen and (min-width: 425px) and (max-width: 760px) and (orientation: landscape) {
    height: 100%;
    max-width: 100%;
    width: 100%;
  }
`

export const AppContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;

  @media (min-width: 425px) {
    justify-content: center;
    align-items: center;
  }

  @media screen and (min-width: 425px) and (max-width: 760px) and (orientation: landscape) {
    height: 100%;
    max-width: 100%;
    width: 100%;
  }
`

export const FakePhone = styled.div`
  background: #fff;
  height: 100%;

  @media (min-width: 425px) {
    height: 100%;
    min-width: 425px;
    max-width: 425px;
    min-height: 720px;
    max-height: 720px;
    overflow: auto hidden;
    position: relative;

    box-shadow: 3px 9px 17px 1px rgba(194, 194, 194, 0.75);
  }

  @media screen and (min-width: 425px) and (max-width: 760px) and (orientation: landscape) {
    height: 100%;
    max-width: 100%;
    width: 100%;
  }
`

export const StackOverflow = styled(Stack)`
  overflow-y: scroll;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 2px;
    margin-right: -4px;
  }

  ::-webkit-scrollbar-button {
    background: #f1f1f1;
    height: 2px;
  }

  ::-webkit-scrollbar-track-piece {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.customerColor};
  }
`

export default GlobalStyle
